export function initLoginForm() {
    $('.form-login-create-btn').click((ev) => {
        ev.preventDefault();
        $('.form-login__container').addClass('d-none');
        $('.form-register__container').removeClass('d-none');
    });
}

export function resetFormVisibility() {
    $('.form-login__container').removeClass('d-none');
    $('.form-register__container').addClass('d-none');
}